
import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import Utils from '@/utils/utils';
import public_tool from '@/common/public.js';

Sentry.init({
  Vue,
  dsn: 'https://9a30b41767a9ae9adaa660150bd4fbfa@sentry.ceekee.com/2',
  release: process.env.SENTRY_RELEASE,
  environment: window.location.hostname,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  debug: false,
  integrations: [
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
    new Sentry.BrowserTracing(),
  ],
});

const settings = public_tool.GetSettings();
const MemberInfo = Utils.get(settings, 'MemberInfo', {});
const CompanyName = Utils.get(settings, 'CompanyName', '');
if (MemberInfo) {
  Sentry.configureScope((scope) => {
    scope.setUser({ ...MemberInfo, CompanyName: CompanyName });
  });
}

